<template>
  <div class="d-flex flex-column align-items-center p-5">
    <h1>CONGRATULATIONS!</h1>
    <p>
      You have successfully submitted to <b>{{ invite.title }}</b
      >.
    </p>
    <artwork :artwork="artwork" v-if="artwork"> </artwork>
    <p>
      You have more to show? The Creative Invite allows you to do so.
    </p>
    <div>
      <b-btn
        class="text-uppercase"
        :to="{
          name: 'application-upload',
          params: {
            inviteId
          }
        }"
      >
        Submit again
      </b-btn>
      <b-btn
        class="text-uppercase"
        :to="`/${artwork.author.username}/?type=application`"
        variant="primary"
      >
        My submission
      </b-btn>
    </div>
  </div>
</template>

<script>
import ArtworkComponent from "../components/Artwork";
import { Invite, Artwork } from "../models";

export default {
  components: {
    Artwork: ArtworkComponent
  },
  props: ["inviteId", "artworkId"],
  data() {
    return {
      invite: new Invite({
        id: this.inviteId
      }),
      artwork: null
    };
  },
  async created() {
    this.invite = await this.invite.load();
    this.artwork = await new Artwork({
      id: this.artworkId
    }).load();
  }
};
</script>
